import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable, BehaviorSubject, Subject } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class SharedService {
  private userLoggedIn = new Subject<boolean>();
  cartcount: any;
  expireAt: any;
  private isOpen: boolean = false;
  constructor(private http: HttpClient) {
    this.cartcount = new BehaviorSubject<any>(0);
    this.userLoggedIn.next(false);
  }

  setUserLoggedIn(userLoggedIn: boolean) {
    this.userLoggedIn.next(userLoggedIn);
  }

  getUserLoggedIn(): Observable<boolean> {
    return this.userLoggedIn.asObservable();
  }
  commonPostHandler(url: string, data: any, options?: any): Observable<any> {
    return this.http.post(url, data, options);
  }

  commonGetHandler(url: string, options?: any): Observable<any> {
    return this.http.get(url, options);
  }
  commonPutHandler(url: string, data: any, options?: any): Observable<any> {
    return this.http.put(url, data, options);
  }

  commonDeleteHandler(url: string, options?: any): Observable<any> {
    return this.http.delete(url, options);
  }
  commonDeleteHandlerWithObject(url: string, data: any, options?: any): Observable<any> {
    return this.http.delete(url, { body: data, ...options });
  }
}
